import axios from 'axios';
const ghl = {

    async generateRequestSignature({
        refNo,
        amount,
        currency,
        token
    }) {
        const response = await axios.post('/v2/api/ghl/generateRequestSignature', {
            refNo,
            amount,
            currency,
        }, {
            timeout: 30000,
            headers: { Authorization: "Bearer " + token },
        });
        return response.data;
    }

}


export default ghl;
